export default "__VITE_ASSET__BcNYiFqQ__"